import React from "react";
import { ShelterBedMetric } from "./ShelterBedMetric";

export const ShelterReservedMetric = ({ data }: any) => (
  <ShelterBedMetric
    data={data}
    title="Reserved Beds"
    subtitle="empty, unusable"
    tooltip="Empty beds inside a dwelling or room already assigned to a case. Nobody else can be offered them."
    field="reserved_beds"
  />
);
